import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { ordersSlice } from "../app/modules/Sale/_redux/orders/ordersSlice";
import { paymentsSlice } from "../app/modules/Sale/_redux/payments/paymentsSlice";
import { customersSlice } from "../app/modules/Sale/_redux/customers/customersSlice";
import { customerGroupsSlice } from "../app/modules/Sale/_redux/customer-groups/customerGroupsSlice";
import { orderReturnSlice } from "../app/modules/Sale/_redux/order-return/orderReturnSlice";
import { saleAttributesSlice } from "../app/modules/Sale/_redux/attributes/attributesSlice";
import { productsSlice } from "../app/modules/Catalog/_redux/products/productsSlice";
import { brandsSlice } from "../app/modules/Catalog/_redux/brands/brandsSlice";
import { categoriesSlice } from "../app/modules/Catalog/_redux/categories/categoriesSlice";
import { suppliersSlice } from "../app/modules/Inventory/_redux/suppliers/suppliersSlice";
import { tagsSlice } from "../app/modules/Catalog/_redux/tags/tagsSlice";
import { purchaseOrdersSlice } from "../app/modules/Inventory/_redux/purchase-orders/purchaseOrdersSlice";
import { purchaseOrderReceiveSlice } from "../app/modules/Inventory/_redux/purchase-order-receive/purchaseOrderReceiveSlice";
import { purchaseOrdersListSlice } from "../app/modules/Inventory/_redux/purchase-orders-list/purchaseOrdersListSlice";
import { purchaseReturnsSlice } from "../app/modules/Inventory/_redux/purchase-returns/purchaseReturnsSlice";
import { stocksSlice } from "../app/modules/Inventory/_redux/stocks/stocksSlice";
import { warehousesSlice } from "../app/modules/Inventory/_redux/warehouses/warehousesSlice";
import { storefrontsSlice } from "../app/modules/Inventory/_redux/storefronts/storefrontsSlice";
import { stockTransferSlice } from "../app/modules/Inventory/_redux/stock-transfer/stockTransferSlice";
import { stockTransferListSlice } from "../app/modules/Inventory/_redux/stock-transfer-list/stockTransferListSlice";
import { stockAlertsSlice } from "../app/modules/Inventory/_redux/stock-alerts/stockAlertsSlice";
import { attributesSlice } from "../app/modules/Catalog/_redux/attributes/attributesSlice";
import { attributesGroupsSlice } from "../app/modules/Catalog/_redux/attributes-groups/attributesGroupsSlice";
import { msaSlice } from "../app/modules/Report/_redux/msa/msaSlice";
import { salesReportSlice } from "../app/modules/Report/_redux/msa/sales-report/salesReportSlice";
import { legalReportSlice } from "../app/modules/Report/_redux/msa/legal-report/legalReportSlice";
import { usersSlice } from "../app/modules/User/_redux/users/usersSlice";
import { dashboardSlice } from "../app/modules/Dashboard/_redux/dashboard/dashboardSlice";
import { basicSettingsSlice } from "../app/modules/Estore/_redux/Estore/basicSettingsSlice";
import { dragColumnSettingsSlice } from "../app/modules/Estore/_redux/Estore/dragColumnSettingsSlice";
import { channelsState } from "../app/modules/Inventory/_redux/sale-stock-channels/saleStockChannelsSlice";
import { usersPermissionSlice } from "../app/modules/User/_redux/user-permissions/usersPermissionSlice";
import { usersRoleSlice } from "../app/modules/User/_redux/user-roles/usersRoleSlice";
import { promotionsSlice } from "../app/modules/Marketing/_redux/promotions/promotionsSlice";
import { sidebarSlice } from "../_metronic/layout/components/aside/navSlice";
import { ChartsOfAccountsSlice } from "../app/modules/Accounting/_redux/charts-of-accounts/ChartsOfAccountsSlice";
import { BillsSlice } from "../app/modules/Accounting/_redux/bills/BillsSlice";
import { vendorsSlice } from "../app/modules/Accounting/_redux/vendors/VendorsSlice";
import { shippingSlice } from "../app/modules/Shipping/_redux/shippingSlice";
import { spiffSlice } from "../app/modules/Spiff/_redux/spiff/spiffSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  orders: ordersSlice.reducer,
  payments: paymentsSlice.reducer,
  customers: customersSlice.reducer,
  customerGroups: customerGroupsSlice.reducer,
  orderReturn: orderReturnSlice.reducer,
  saleAttributes: saleAttributesSlice.reducer,
  products: productsSlice.reducer,
  brands: brandsSlice.reducer,
  categories: categoriesSlice.reducer,
  suppliers: suppliersSlice.reducer,
  tags: tagsSlice.reducer,
  channelsState: channelsState.reducer,
  warehouses: warehousesSlice.reducer,
  storefronts: storefrontsSlice.reducer,
  promotions: promotionsSlice.reducer,
  bills: BillsSlice.reducer,
  chartsOfAccounts: ChartsOfAccountsSlice.reducer,
  vendors: vendorsSlice.reducer,
  purchaseOrders: purchaseOrdersSlice.reducer,
  purchaseOrdersReceives: purchaseOrderReceiveSlice.reducer,
  purchaseOrdersList: purchaseOrdersListSlice.reducer,
  purchaseReturns: purchaseReturnsSlice.reducer,
  stocks: stocksSlice.reducer,
  stockTransfer: stockTransferSlice.reducer,
  stockTransferList: stockTransferListSlice.reducer,
  stockAlertsState: stockAlertsSlice.reducer,
  attributes: attributesSlice.reducer,
  attributesGroups: attributesGroupsSlice.reducer,
  msaReport: msaSlice.reducer,
  salesReport: salesReportSlice.reducer,
  legalReport: legalReportSlice.reducer,
  users: usersSlice.reducer,
  dashboard: dashboardSlice.reducer,
  basicSettings: basicSettingsSlice.reducer,
  dragColumnSettings: dragColumnSettingsSlice.reducer,
  groupPermissions: usersPermissionSlice.reducer,
  userRoles: usersRoleSlice.reducer,
  sideBar: sidebarSlice.reducer,
  shipping: shippingSlice.reducer,
  spiff: spiffSlice.reducer,
});
